module.exports = __webpack_public_path__ + "img/tv8.6ed41c08.gif";